@import url('https://fonts.googleapis.com/css2?family=Exo+2:wght@400;500&family=Inter:wght@400;500;600;700;800&display=swap');

@import "tailwindcss";

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  background: #e9ebf6;
  color: #131a54;
  font-family: Inter, Arial, Helvetica, sans-serif;
}

.tecma-brand-wordmark {
  font-family: 'Exo 2', Arial, Helvetica, sans-serif;
}
